export const iconFontAwesomeDisasterCrisisMosquito = (
	<i className="fa-solid fa-mosquito"></i>
);
